



















































import {
  Component, Vue,
} from 'vue-property-decorator';

import LayoutContent from '@/components/LayoutContent.vue';
import Checkbox from '@/components/Checkbox.vue';

import ChevronIcon from 'mdi-vue/ChevronRight';
import api from '@/libs/api';

@Component({
  components: {
    LayoutContent,
    Checkbox,
    ChevronIcon,
  },
})

export default class InternalBillingList extends Vue {
  /* eslint-disable */
  mounted() {
    this.loadData();
  }

  selectedPeriod: any = {};
  merchantData: any = {
    merchant_code: '',
    merchant_name: '',
    address: '',
  };
  billingList: any = [];

  async loadData() {
    // const { data } = await api.get(`recon/traffic/M5a7286048eda6`);
    const { data } = await api.get(`recon/traffic/${this.$route.params.merchant_code}`);
    // M5a7286048eda6
    // M5c24b2f9ba9d0
    // M5f351c72a6547 prismalink
    // M5701ca121364e citilink
    if (data.status === true) {
      this.billingList = data.data.billing_list_internal;
      for (const key in this.merchantData) {
        this.merchantData[key] = data.data[key];
      }
      this.billingList = this.billingList.filter((data: any) => data.merchant_traffic.length > 0);
      //   .filter((data: any) => data.bill_type == 'Normal'); // hanya menampilkan yang bill type normal
      this.selectedPeriod = {};
      this.billingList.forEach((data: any) => {
        Vue.set(data, 'expanded', false);
        data.merchant_traffic.forEach((val: any) => {
          if (val.credential_code == this.$route.params.credential_code && val.periode_slug == this.$route.params.periode_slug) {
            Vue.set(data, 'expanded', true);
            this.selectedPeriod = val;
            this.selectPeriod(data, val);
          }
        })
      });
    }
  }

  selectPeriod(itemData: any, item2Data: any) {
    try {
      this.selectedPeriod = item2Data;
      this.$emit('selectPeriod', {
        ...itemData,
        merchant_traffic: item2Data,
        merchantData: this.merchantData,
      });
    } catch (error) {
      console.log(error);
    }
  }
}
